// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-multiselect .v-icon{color:#178fcf !important;cursor:pointer}.czt-multiselect.v-text-field--solo{border-radius:0}.czt-multiselect .v-input__slot{box-shadow:0 1px 1px -2px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.05),0 1px 5px 0 rgba(0,0,0,.12) !important}", ""]);
// Exports
module.exports = exports;
